/**
 * Formats a number with K/M/B abbreviations
 * @param value - The number to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string (e.g., "11.2K", "1.5M")
 */
export function formatAbbreviatedNumber(value: number, decimals: number = 1): string {
  if (value < 1000) {
    return value.toString()
  }

  const units = ['', 'K', 'M', 'B', 'T']
  const order = Math.floor(Math.log10(Math.abs(value)) / 3)
  const unitIndex = Math.min(order, units.length - 1)
  const scaledValue = value / Math.pow(1000, unitIndex)

  // Remove trailing zeros and decimal point if not needed
  const formatted = scaledValue.toFixed(decimals).replace(/\.0+$/, '')

  return `${formatted}${units[unitIndex]}`
}

/**
 * Converts basis points to percentage string
 * @param basisPoints - The basis points value (e.g., 200 = 2%)
 * @returns Formatted percentage string (e.g., "2.0%")
 */
export function formatBasisPoints(basisPoints: number): string {
  return `${(basisPoints / 100).toFixed(1)}%`
}

/**
 * Formats a number with locale string (commas)
 * @param value - The number to format
 * @returns Formatted string (e.g., "1,234,567")
 */
export function formatNumber(value: number): string {
  return value.toLocaleString('en-US')
}
